import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { getConnection, hideSpinner, showSpinner, getCurrentUser } from 'src/app/core/services/functions.service';
import { LogisticaService } from '../services/logistica.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { DialogComboCreationComponent } from '../dialog-combo-creation/dialog-combo-creation.component';
import { ModalAlertasComponent } from '../modal-alertas/modal-alertas.component';
import { ModalCapacidadDiasComponent } from '../modal-capacidad-dias/modal-capacidad-dias.component';
import { ModalHistoricoPoligonoComponent } from '../modal-historico-poligono/modal-historico-poligono.component';
import { ModalHistoricoGeografiaComponent } from '../modal-historico-geografia/modal-historico-geografia.component';
import { ModalHistoricoCapacidadesComponent } from '../modal-historico-capacidades/modal-historico-capacidades.component';
import { FormControl } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { NotificationHelper } from 'src/app/core/services/helpers/notification.helper';
import { CommonService } from 'src/app/modules/shared/imports/services/common.service'



@Component({
  selector: 'app-crear-poligono',
  templateUrl: './crear-poligono.component.html',
  styleUrls: ['./crear-poligono.component.scss']
})
export class CrearPoligonoComponent implements OnInit {
  company_id: string = '';
  class: string = " "
  title: string = "Listado de Cúbica+"
  description: string = "Seleccione un registro para modificar."
  description2: string = "Puedes agregar o eliminar geografías, por departamentos, municipios o zonas."
  description3: string = "Puedes agregar o eliminar capacidades."
  title2: string = "Selección Geográfica por Cúbica+"
  title3: string = "Capacidades Cúbica+ por bodega"
  cod_poligono: any;
  nom_poligono: any;
  estado: any;
  usuario: any;
  data: any[] = [];
  data_capa: any[] = [];
  bandera: boolean = true;
  bandera2: boolean = true;
  cod_poligono_geogr: any;
  // Observables para el filtro
  departamentos: Observable<any[]> = of([]);
  municipios: Observable<any[]> = of([]);
  zonas: Observable<any[]> = of([]);
  // Datos originales
  departamentosOriginal: any[] = [];
  municipiosOriginal: any[] = [];
  zonasOriginal: any[] = [];
  // Controles para cada campo
  departamentoControl = new FormControl();
  municipioControl = new FormControl();
  zonaControl = new FormControl();
  departamentosSeleccionados: any[] = [];
  // Municipios seleccionados
  municipiosSeleccionados: any[] = [];
  zonasSeleccionadas: any[] = [];
  // Propiedades para la tabla
  dataSource: MatTableDataSource<any>;
  dataSourCapa: MatTableDataSource<any>;
  columns: any[] = [
    { name: 'ID_POLI', title: 'Id_poli', type: 'text' },
    { name: 'COD_POLIGONO', title: 'Código', type: 'text' },
    { name: 'NOMBRE_POLIGONO', title: 'Nombre', type: 'text' },
    { name: 'ESTADO_LEGIBLE', title: 'Estado', type: 'text' },
    { name: 'USUARIO_CREACION', title: 'Usuario_creacion', type: 'text' },
    { name: 'USUARIO_MODIFICACION', title: 'Usuario_modificacion', type: 'text' },
    { name: 'actions', title: 'Acciones', type: 'actions' }
  ];
  columns_capa: any[] = [
    { name: 'ID_REG', title: 'id_reg', type: 'text' },
    { name: 'COD_BODEGA', title: 'Bodega', type: 'text' },
    { name: 'CIERRE_AUTOMATICO', title: 'cierre_automatico', type: 'text' },
    { name: 'PORCENTAJE_CIERRE', title: '%_cierre', type: 'text' },
    { name: 'CUBICAJE_TOTAL', title: 'cubicaje_total', type: 'text' },
    { name: 'CANTIDAD_ORD_TOTAL', title: 'cantidad_ord_total', type: 'text' },
    { name: 'USUARIO_CREACION', title: 'Usuario_creacion', type: 'text' },
    { name: 'USUARIO_MODIFICACION', title: 'Usuario_modificacion', type: 'text' },
    { name: 'FECHA_CREACION', title: 'fecha_creacion', type: 'text' },
    { name: 'FECHA_MODIFICACION', title: 'fecha_modificacion', type: 'text' },
    { name: 'actions', title: 'Acciones', type: 'actions' }
  ];
  displayedColumns: string[] = [];
  displayedColumns_capa: string[] = [];
  pageSizeOptions: number[] = [5, 10, 25, 50];
  pageSizeOptions_capa: number[] = [5, 10, 25, 50];
  selected = new Set<any>();
  selected_capa = new Set<any>();
  habilitarDepar: boolean = true;
  habilitarMunicipio: boolean = false;
  habilitarZona: boolean = false;
  selectedRow: any = null;
  selectedRow_capa: any = null;
  editandoCapacidad: any = null;
  editCapaForm: { CIERRE_AUTOMATICO: string; PORCENTAJE_CIERRE: number; CUBICAJE_TOTAL: number; CANTIDAD_ORD_TOTAL: number } = {
    CIERRE_AUTOMATICO: 'S', PORCENTAJE_CIERRE: 97, CUBICAJE_TOTAL: 0, CANTIDAD_ORD_TOTAL: 0
  };
  filtroDepartamento: string = '';
  filtroMunicipio: string = '';
  filtroZona: string = '';
  storeBodegas: Item[] = [];


  @ViewChild('paginatorPoligono') paginatorPoligono!: MatPaginator;
  @ViewChild('paginatorCapa') paginatorCapa!: MatPaginator;
  @ViewChild('editCapaDialog') editCapaDialogTpl!: TemplateRef<any>;
  private editCapaDialogRef: MatDialogRef<any> | null = null;
  static switch: any = 0;

  constructor(
    private logisticaService: LogisticaService,
    private dialog: MatDialog,
    private notificationService: NotificationHelper,
    private commonService: CommonService,
  ) {
    // Inicialmente, las secciones de selección geográfica y capacidades están deshabilitadas
    // hasta que se seleccione un registro
    this.bandera = false;
    this.bandera2 = false;
  }
  
  /**
   * Carga las bodegas desde el servicio para poder mostrar sus nombres
   */
  async cargarBodegas(): Promise<void> {
    try {
      const bodegas = await this.commonService.findAllBodegas();
      if (bodegas && bodegas.data) {
        this.storeBodegas = bodegas.data.map((d) => {
          return {
            cod: d.c_bod,
            nombre: d.nom
          };
        });
      }
    } catch (error) {
      console.error('Error al cargar bodegas:', error);
      this.notificationService.errorMessage('No se pudieron cargar las bodegas', 'Intente nuevamente más tarde');
    }
  }

  ngOnChanges() {
    this.ngOnInit();
  }
  static async changeValueDialog(value: any) {
    this.switch = value;
  }

  async ngOnInit(): Promise<void> {
    this.cod_poligono = '';
    this.nom_poligono = '';
    this.usuario = getCurrentUser().usuario_aplicativo || '';
    // mantener la seleccion 
    if (this.selectedRow) {
      await this.selectRow(this.selectedRow);
    }
    
    // Reiniciar la selección
    this.selected.clear();
    this.selectedRow = null;
    this.selectedRow_capa = null;
    this.cod_poligono_geogr = '';

    // Reiniciar listas
    this.departamentosSeleccionados = [];
    this.municipiosSeleccionados = [];
    this.zonasSeleccionadas = [];
    this.refrescarGeografias();

    // Inicializar displayedColumns con los nombres de las columnas
    this.displayedColumns = this.columns.map(column => column.name);

    // Inicializar displayedColumns_capa con los nombres de las columnas de capacidades
    this.displayedColumns_capa = ['ID_REG', 'COD_BODEGA', 'CIERRE_AUTOMATICO', 'PORCENTAJE_CIERRE', 'CUBICAJE_TOTAL', 'CANTIDAD_ORD_TOTAL', 'USUARIO_CREACION', 'USUARIO_MODIFICACION', 'actions'];
    
    // Cargar las bodegas para poder mostrar sus nombres
    await this.cargarBodegas();
    
    showSpinner();
    try {
      const response = await this.logisticaService.obtener_poligono();

      if (response && response.success) {
        // Normalizar los campos
        this.data = response.data.map((item: any) => ({
          id_poli: item.ID_POLI,
          cod_poligono: item.COD_POLIGONO,
          nom_poligono: item.NOMBRE_POLIGONO,
          estado: item.ESTADO,
          usuario_cre: item.USUARIO_CREACION, // Cambia esto si el nombre es distinto
          usuario_mod: item.USUARIO_MODIFICACION,
          fecha_cre: item.FECHA_CREACION,
          fecha_mod: item.FECHA_MODIFICACION,
          ...item // Para no perder las otras propiedades si las necesitas en acciones
        }));
        this.dataSource = new MatTableDataSource<any>(this.data);
        this.dataSource.paginator = this.paginatorPoligono
      } else {
        // Aquí puedes mostrar el mensaje de error si no fue exitoso
        this.notificationService.infoMessage("Aun no cuentas con polígonos guardados.");
        //this.notificationService.errorMessage("Ocurrió un error.", response.message || 'No se pudieron obtener los polígonos.');
      }
    } catch (error) {
      console.error('Error al obtener polígonos:', error);
    } finally {
      hideSpinner();
    }
  }



  /**
   * Renderiza el valor de una celda según su tipo
   */
  render(column: any, element: any): string {
    const value = element[column.name];
    if (value === undefined || value === null) {
      return '';
    }
    // Mostrar "Sí" o "No" en CIERRE_AUTOMATICO
    if (column.name === 'CIERRE_AUTOMATICO') {
      return value === 'S' ? 'Sí' : 'No';
    }

    // Mostrar nombre de bodega y código entre paréntesis
    if (column.name === 'COD_BODEGA') {
      const codBodega = value.toString();
      const bodega = this.storeBodegas.find(b => b.cod === codBodega);
      if (bodega) {
        return `${bodega.nombre} (${codBodega})`;
      }
      return codBodega;
    }

    if (column.name === 'USUARIO_CREACION') {
      const usuario = element.USUARIO_CREACION || '';
      const fecha = element.FECHA_CREACION || '';
      return `${usuario}<br>${fecha}`;
    } else if (column.name === 'USUARIO_MODIFICACION') {
      const usuario = element.USUARIO_MODIFICACION || '';
      const fecha = element.FECHA_MODIFICACION
        ? new Date(element.FECHA_MODIFICACION).toLocaleString('es-CO', {
          day: '2-digit', month: '2-digit', year: 'numeric',
          hour: '2-digit', minute: '2-digit'
        })
        : '';
      return usuario ? `${usuario}<br>${fecha}` : '';
    }

    return value.toString();
  }

  async openDialog(action, data) {
    const dialogConfig = new MatDialogConfig();
    data.action = action;
    dialogConfig.data = data;
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '100%';
    dialogConfig.height = 'fit-content';
    const dialogRef = this.dialog.open(
      DialogComboCreationComponent,
      dialogConfig
    );
    dialogRef.afterClosed().subscribe(async (result) => {
      if (CrearPoligonoComponent.switch == 1) {
        await this.ngOnInit();
      }
      CrearPoligonoComponent.switch = 0;
    });
    /* dialogRef.afterClosed().subscribe(async (result) => {
      console.log(result?.success,result.refresh,this.selectedRow);
      if (result?.success && result.refresh) {
        this.ngOnInit()
        if(this.selectedRow){
          this.selectRow(this.selectedRow.tipo)
        }else if (['departamento', 'municipio', 'zona'].includes(result.id_poli)) {
          await this.recargarGeografia(this.selectedRow.id_poli);
        } else if (result.tipo === 'new_capa') {
          await this.recargarCapacidades(this.selectedRow.id_poli);
        }
      }
    }); */
  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  applyFilterCapacidades(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSourCapa.filter = filterValue;

    if (this.dataSourCapa.paginator) {
      this.dataSourCapa.paginator.firstPage();
    }
  }

  async selectRow(row: any) {
    this.selected.clear();
    this.selected.add(row);
    this.selectedRow = row;
    this.cod_poligono_geogr = row.ID_POLI;
    this.bandera = true;
    this.bandera2 = true;
    this.notificationService.infoMessage(`Cúbica+ seleccionada: ${row.NOMBRE_POLIGONO}`);

    try {
      showSpinner();
      const response = await this.logisticaService.obtener_geografia(this.cod_poligono_geogr);
      if (response?.success && Array.isArray(response.data)) {
        // Reiniciar listas
        this.departamentosSeleccionados = [];
        this.municipiosSeleccionados = [];
        this.zonasSeleccionadas = [];

        response.data.forEach(item => {
          // Si solo COD_DPTO está lleno -> llenar card departamento
          if (item.COD_DPTO && !item.COD_MNPO && !item.COD_ZONA_LOG && item.NOMBRE_DEPARTAMENTO) {
            this.departamentosSeleccionados.push({
              CODIGO_DEPARTAMENTO: item.COD_DPTO,
              NOMBRE_DEPARTAMENTO: item.NOMBRE_DEPARTAMENTO
            });
          }
          // Si COD_DPTO y COD_MNPO están llenos pero COD_ZONA_LOG vacío -> llenar card municipio
          else if (item.COD_DPTO && item.COD_MNPO && !item.COD_ZONA_LOG && item.NOMBRE_MUNICIPIO) {
            this.municipiosSeleccionados.push({
              CODIGO_MUNICIPIO: item.COD_MNPO,
              NOMBRE_MUNICIPIO: item.NOMBRE_MUNICIPIO,
              COD_DPTO: item.COD_DPTO
            });
          }
          // Si los tres códigos están llenos -> llenar card zona
          else if (item.COD_DPTO && item.COD_MNPO && item.COD_ZONA_LOG && item.NOMBRE_ZONA) {
            this.zonasSeleccionadas.push({
              CODIGO_ZONA: item.COD_ZONA_LOG,
              NOMBRE_ZONA: item.NOMBRE_ZONA,
              COD_DPTO: item.COD_DPTO
            });
          }
        });
      }
    } catch (error) {
      console.error('Error al cargar geografía:', error);
    } finally {
      hideSpinner();
    }

    try {
      showSpinner();
      const responseCapa = await this.logisticaService.obtener_capacidades(this.cod_poligono_geogr);
      console.log('Respuesta capacidades:', responseCapa);

      if (responseCapa && (responseCapa.success || responseCapa.status === "success")) {
        // Normalizar los datos para tener un ID único
        this.data_capa = (responseCapa.data || []).map(item => ({
          ...item,
          // Usar ID_REG si existe, sino usar ID_REG_CAL
          ID_REG: item.ID_REG || item.ID_REG_CAL,
          // Agregar un campo para identificar el tipo
          TIPO_CAPACIDAD: item.ID_REG ? 'GENERAL' : 'POR_DIA'
        }));
        console.log('Datos capacidades normalizados:', this.data_capa);

        // Asegurarse de que displayedColumns_capa esté configurado correctamente
        if (!this.displayedColumns_capa || this.displayedColumns_capa.length === 0) {
          this.columns_capa = [
            { name: 'ID_REG', title: 'ID' },
            { name: 'COD_BODEGA', title: 'Bodega' },
            { name: 'CIERRE_AUTOMATICO', title: 'Cierre Auto' },
            { name: 'PORCENTAJE_CIERRE', title: '% Cierre' },
            { name: 'CUBICAJE_TOTAL', title: 'Cubicaje' },
            { name: 'CANTIDAD_ORD_TOTAL', title: 'Cant. Órdenes' },
            { name: 'USUARIO_CREACION', title: 'Usuario_creacion', type: 'text' },
            { name: 'USUARIO_MODIFICACION', title: 'Usuario_modificacion', type: 'text' },
            { name: 'FECHA_CREACION', title: 'fecha_creacion', type: 'text' },
            { name: 'FECHA_MODIFICACION', title: 'fecha_modificacion', type: 'text' },
            { name: 'actions', title: 'Acciones', type: 'actions' }
          ];
          this.displayedColumns_capa = this.columns_capa.map(col => col.name);
        }

        this.dataSourCapa = new MatTableDataSource<any>(this.data_capa);
        this.dataSourCapa.paginator = this.paginatorCapa;
      } else {
        this.data_capa = [];
        this.dataSourCapa = new MatTableDataSource<any>([]);
        this.notificationService.infoMessage("Aun no cuentas con capacidades guardadas.");
      }
    } catch (error) {
      console.error('Error al cargar capacidades:', error);
      this.data_capa = [];
      this.dataSourCapa = new MatTableDataSource<any>([]);
    } finally {
      hideSpinner();
    }
  }

  async selectRow_capa(row: any) {
    this.selected_capa.clear();
    this.selected_capa.add(row);
    this.selectedRow_capa = row;
    this.notificationService.infoMessage(`Capacidad seleccionado: ${row.COD_BODEGA}`);

  }

  async refrescarGeografias() {
    if (!this.selectedRow?.ID_POLI) return;
    
    try {
      showSpinner();
      const response = await this.logisticaService.obtener_geografia(this.selectedRow.ID_POLI);
      if (response?.success && Array.isArray(response.data)) {
        this.departamentosSeleccionados = [];
        this.municipiosSeleccionados = [];
        this.zonasSeleccionadas = [];

        response.data.forEach(item => {
          // Si solo COD_DPTO está lleno -> llenar card departamento
          if (item.COD_DPTO && !item.COD_MNPO && !item.COD_ZONA_LOG && item.NOMBRE_DEPARTAMENTO) {
            this.departamentosSeleccionados.push({
              CODIGO_DEPARTAMENTO: item.COD_DPTO,
              NOMBRE_DEPARTAMENTO: item.NOMBRE_DEPARTAMENTO
            });
          }
          // Si COD_DPTO y COD_MNPO están llenos pero COD_ZONA_LOG vacío -> llenar card municipio
          else if (item.COD_DPTO && item.COD_MNPO && !item.COD_ZONA_LOG && item.NOMBRE_MUNICIPIO) {
            this.municipiosSeleccionados.push({
              CODIGO_MUNICIPIO: item.COD_MNPO,
              NOMBRE_MUNICIPIO: item.NOMBRE_MUNICIPIO,
              COD_DPTO: item.COD_DPTO
            });
          }
          // Si los tres códigos están llenos -> llenar card zona
          else if (item.COD_DPTO && item.COD_MNPO && item.COD_ZONA_LOG && item.NOMBRE_ZONA) {
            this.zonasSeleccionadas.push({
              CODIGO_ZONA: item.COD_ZONA_LOG,
              NOMBRE_ZONA: item.NOMBRE_ZONA,
              COD_DPTO: item.COD_DPTO
            });
          }
        });
        this.notificationService.successMessage("Geografías actualizadas correctamente");
      }
    } catch (error) {
      console.error('Error al cargar geografía:', error);
      this.notificationService.errorMessage("Error al actualizar las geografías");
    } finally {
      hideSpinner();
    }
  }


  departamentosFiltrados() {
    // Filtrar por el texto de búsqueda
    const filtrados = this.departamentosSeleccionados.filter(d =>
      d.NOMBRE_DEPARTAMENTO.toLowerCase().includes(this.filtroDepartamento.toLowerCase()));

    // Eliminar duplicados usando un Map para mantener solo una ocurrencia por nombre
    const uniqueMap = new Map();
    filtrados.forEach(depto => {
      if (!uniqueMap.has(depto.NOMBRE_DEPARTAMENTO)) {
        uniqueMap.set(depto.NOMBRE_DEPARTAMENTO, depto);
      }
    });

    // Convertir el Map de vuelta a un array
    return Array.from(uniqueMap.values());
  }

  municipiosFiltrados() {
    const filtrados = this.municipiosSeleccionados.filter(m =>
      m.NOMBRE_MUNICIPIO.toLowerCase().includes(this.filtroMunicipio.toLowerCase()));
    
    const uniqueMap = new Map();
    filtrados.forEach(municipio => {
      const key = `${municipio.NOMBRE_MUNICIPIO}-${municipio.CODIGO_DEPARTAMENTO}`;
      if (!uniqueMap.has(key)) {
        uniqueMap.set(key, municipio);
      }
    });
    
    return Array.from(uniqueMap.values());
  }

  zonasFiltradas() {
    const filtrados = this.zonasSeleccionadas.filter(z =>
      z.NOMBRE_ZONA.toLowerCase().includes(this.filtroZona.toLowerCase()));
    
    const uniqueMap = new Map();
    filtrados.forEach(zona => {
      const key = `${zona.NOMBRE_ZONA}-${zona.COD_DPTO}`;
      if (!uniqueMap.has(key)) {
        uniqueMap.set(key, zona);
      }
    });
    
    return Array.from(uniqueMap.values());
  }



  async eliminarGeografia(tipo: string, item: any, id_poli: any) {
    try {
      showSpinner();
      let codigo = '';

      switch (tipo) {
        case 'departamento':
          codigo = item.CODIGO_DEPARTAMENTO;
          break;
        case 'municipio':
          codigo = item.CODIGO_MUNICIPIO;
          break;
        case 'zona':
          codigo = item.CODIGO_ZONA;
          break;
      }

      const response = await this.logisticaService.eliminar_geografia(tipo, codigo, id_poli.ID_POLI);

      if (response.success) {
        this.notificationService.successMessage(response.message || "Geografía eliminada correctamente");

        // Actualizar las listas locales
        this.departamentosSeleccionados = this.departamentosSeleccionados.filter(d => d !== item);
        this.municipiosSeleccionados = this.municipiosSeleccionados.filter(m => m !== item);
        this.zonasSeleccionadas = this.zonasSeleccionadas.filter(z => z !== item);
      } else {
        this.notificationService.errorMessage(response.message || "Error al eliminar la geografía");
      }
    } catch (error) {
      console.error('Error al eliminar geografía:', error);
      this.notificationService.errorMessage("Se produjo un error al eliminar la geografía");
    } finally {
      hideSpinner();
    }
  }

  iniciarEdicionCapacidad(item: any): void {
    this.editandoCapacidad = item;
    this.editCapaForm = {
      CIERRE_AUTOMATICO: item.CIERRE_AUTOMATICO || 'S',
      PORCENTAJE_CIERRE: item.PORCENTAJE_CIERRE || 97,
      CUBICAJE_TOTAL: item.CUBICAJE_TOTAL || 0,
      CANTIDAD_ORD_TOTAL: item.CANTIDAD_ORD_TOTAL || 0
    };
    this.editCapaDialogRef = this.dialog.open(this.editCapaDialogTpl, {
      width: '520px',
      disableClose: true,
      autoFocus: true
    });
  }

  cancelarEdicionCapacidad(): void {
    this.editCapaDialogRef?.close();
    this.editandoCapacidad = null;
  }

  async guardarEdicionCapacidad(): Promise<void> {
    showSpinner();
    try {
      const usuario = getCurrentUser()?.usuario_aplicativo || '';
      const res = await this.logisticaService.update_capacidades(
        String(this.editandoCapacidad.ID_REG),
        String(this.editandoCapacidad.COD_BODEGA),
        this.editCapaForm.CIERRE_AUTOMATICO,
        this.editCapaForm.PORCENTAJE_CIERRE,
        this.editCapaForm.CUBICAJE_TOTAL,
        this.editCapaForm.CANTIDAD_ORD_TOTAL,
        usuario
      );
      if (res.success) {
        this.notificationService.successMessage(res.message || 'Capacidad actualizada correctamente.');
        // Actualizar el registro localmente en la tabla
        const idx = this.data_capa.findIndex(c => c.ID_REG === this.editandoCapacidad.ID_REG);
        if (idx !== -1) {
          this.data_capa[idx] = {
            ...this.data_capa[idx],
            CIERRE_AUTOMATICO: this.editCapaForm.CIERRE_AUTOMATICO,
            PORCENTAJE_CIERRE: this.editCapaForm.PORCENTAJE_CIERRE,
            CUBICAJE_TOTAL: this.editCapaForm.CUBICAJE_TOTAL,
            CANTIDAD_ORD_TOTAL: this.editCapaForm.CANTIDAD_ORD_TOTAL,
            USUARIO_MODIFICACION: usuario
          };
          this.dataSourCapa = new MatTableDataSource<any>([...this.data_capa]);
          this.dataSourCapa.paginator = this.paginatorCapa;
        }
        this.editCapaDialogRef?.close();
        this.editandoCapacidad = null;
      } else {
        this.notificationService.errorMessage(res.message || 'Error al actualizar la capacidad.');
      }
    } catch (error) {
      this.notificationService.errorMessage('Error al actualizar la capacidad.');
    } finally {
      hideSpinner();
    }
  }

  confirmarEliminarCapacidad(item: any) {
    this.notificationService.warningDialog(
      'Confirmar eliminación',
      '¿Está seguro de eliminar esta capacidad? Esta acción no se puede deshacer.',
      'Aceptar',
      () => this.eliminarCapacidad(item),
      '450px'
    );
  }

  async eliminarCapacidad(item: any) {
    showSpinner();
    try {
      const idParaEliminar = item.ID_REG || item.ID_REG_CAL;
      const response = await this.logisticaService.eliminarCapacidad(idParaEliminar);

      if (response.success) {
        this.notificationService.successMessage(response.message || "Capacidad eliminada correctamente");
        // Quitar el registro de la tabla localmente de inmediato
        this.data_capa = this.data_capa.filter(c => (c.ID_REG || c.ID_REG_CAL) !== idParaEliminar);
        this.dataSourCapa = new MatTableDataSource<any>(this.data_capa);
        this.dataSourCapa.paginator = this.paginatorCapa;
      } else {
        this.notificationService.errorMessage(response.message || "Error al eliminar la capacidad");
      }
    } catch (error) {
      console.error('Error al eliminar capacidad:', error);
      this.notificationService.errorMessage("Se produjo un error al eliminar la capacidad");
    } finally {
      hideSpinner();
    }
  }

  abrirModalAlertas(element: any) {
    const dialogConfig = new MatDialogConfig();
    // Asegurar que se pase el ID correcto para las alertas
    const dataParaModal = {
      ...element,
      ID_REG_CAPAC: element.ID_REG || element.ID_REG_CAL
    };
    dialogConfig.data = dataParaModal;
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '800px';
    dialogConfig.height = 'fit-content';
    
    const dialogRef = this.dialog.open(ModalAlertasComponent, dialogConfig);
    
    dialogRef.afterClosed().subscribe(result => {
      console.log('Modal de alertas cerrado');
    });
  }

  abrirModalCapacidadDias(element: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      ID_POLI: this.selectedRow?.ID_POLI,
      COD_BODEGA: element.COD_BODEGA
    };
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '95%';
    dialogConfig.maxWidth = '1200px';
    dialogConfig.height = 'fit-content';
    
    const dialogRef = this.dialog.open(ModalCapacidadDiasComponent, dialogConfig);
    
    dialogRef.afterClosed().subscribe(result => {
      console.log('Modal de capacidad días cerrado');
    });
  }

  async abrirModalAgregar(action: 'departamento' | 'municipio' | 'zona', data) {
    // Opcional: podrías pasar el tipo al componente modal
    const dialogConfig = new MatDialogConfig();
    data.action = action;
    dialogConfig.data = data;
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '600px';
    dialogConfig.height = 'fit-content';
    const dialogRef = this.dialog.open(DialogComboCreationComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(async result => {
      console.log('Modal cerrado con resultado:', result);
      if (result && result.success) {
        // Si el modal devolvió un resultado exitoso, recargar los datos
        await this.ngOnInit();
        this.notificationService.successMessage("Datos actualizados correctamente");
      }
    });
  }

  async recargarGeografia(id_poli: any) {
    try {
      showSpinner();
      const response = await this.logisticaService.obtener_geografia(id_poli);
      if (response?.success && Array.isArray(response.data)) {
        this.departamentosSeleccionados = [];
        this.municipiosSeleccionados = [];
        this.zonasSeleccionadas = [];

        response.data.forEach(item => {
          if (item.COD_DPTO && item.NOMBRE_DEPARTAMENTO) {
            this.departamentosSeleccionados.push({
              CODIGO_DEPARTAMENTO: item.COD_DPTO,
              NOMBRE_DEPARTAMENTO: item.NOMBRE_DEPARTAMENTO
            });
          }
          if (item.COD_MNPO && item.NOMBRE_MUNICIPIO) {
            this.municipiosSeleccionados.push({
              CODIGO_MUNICIPIO: item.COD_MNPO,
              NOMBRE_MUNICIPIO: item.NOMBRE_MUNICIPIO,
              CODIGO_DEPARTAMENTO: item.COD_DPTO
            });
          }
          if (item.COD_ZONA_LOG && item.NOMBRE_ZONA) {
            this.zonasSeleccionadas.push({
              CODIGO_ZONA: item.COD_ZONA_LOG,
              NOMBRE_ZONA: item.NOMBRE_ZONA,
              CODIGO_DEPARTAMENTO: item.COD_DPTO,
              CODIGO_MUNICIPIO: item.COD_MNPO
            });
          }
        });
      }
    } catch (error) {
      console.error('Error al recargar geografía:', error);
    } finally {
      hideSpinner();
    }
  }

  abrirModalHistorico(idPoligono: number) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { idPoligono };
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '900px';
    
    this.dialog.open(ModalHistoricoPoligonoComponent, dialogConfig);
  }

  abrirModalHistoricoGeografia() {
    if (!this.selectedRow?.ID_POLI) return;
    
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { idPoligono: this.selectedRow.ID_POLI };
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '1000px';
    
    this.dialog.open(ModalHistoricoGeografiaComponent, dialogConfig);
  }

  abrirModalHistoricoCapacidades() {
    if (!this.selectedRow?.ID_POLI) return;
    
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { idPoligono: this.selectedRow.ID_POLI };
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '95%';
    dialogConfig.maxWidth = '1200px';
    
    this.dialog.open(ModalHistoricoCapacidadesComponent, dialogConfig);
  }

  async recargarCapacidades(id_poli: any) {
    if (!id_poli) return;
    try {
      showSpinner();
      if (this.storeBodegas.length === 0) {
        await this.cargarBodegas();
      }
      const responseCapa = await this.logisticaService.obtener_capacidades(id_poli);
      if (responseCapa?.success) {
        this.data_capa = (responseCapa.data || []).map((item: any) => ({
          ...item,
          ID_REG: item.ID_REG || item.ID_REG_CAL,
          TIPO_CAPACIDAD: item.ID_REG ? 'GENERAL' : 'POR_DIA'
        }));
        this.dataSourCapa = new MatTableDataSource<any>(this.data_capa);
        this.dataSourCapa.paginator = this.paginatorCapa;
      }
    } catch (error) {
      console.error('Error al recargar capacidades:', error);
    } finally {
      hideSpinner();
    }
  }


}

interface Item {
  cod: string;
  nombre: string;
}